import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      id: 'total',
      label: 'Total Shipments',
      value: stats?.total?.toLocaleString(),
      icon: 'Package',
      color: 'primary',
      trend: { value: '+12.5%', direction: 'up' }
    },
    {
      id: 'delivered',
      label: 'Delivered',
      value: stats?.delivered?.toLocaleString(),
      icon: 'CheckCircle2',
      color: 'success',
      trend: { value: '+8.3%', direction: 'up' }
    },
    {
      id: 'in-transit',
      label: 'In Transit',
      value: stats?.inTransit?.toLocaleString(),
      icon: 'Truck',
      color: 'warning',
      trend: { value: '-3.2%', direction: 'down' }
    },
    {
      id: 'exceptions',
      label: 'Exceptions',
      value: stats?.exceptions?.toLocaleString(),
      icon: 'AlertTriangle',
      color: 'error',
      trend: { value: '+2.1%', direction: 'up' }
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-18 mb-24">
      {statCards?.map(card => (
        <div 
          key={card?.id}
          className="bg-card border border-border rounded-lg p-24 hover:shadow-elevation-2 transition-smooth"
        >
          <div className="flex items-start justify-between mb-18">
            <div className={`w-[48px] h-[48px] rounded-lg bg-${card?.color}/10 flex items-center justify-center`}>
              <Icon 
                name={card?.icon} 
                size={24} 
                color={`var(--color-${card?.color})`}
                strokeWidth={2} 
              />
            </div>
            <div className={`
              flex items-center gap-4 px-8 py-4 rounded-full
              ${card?.trend?.direction === 'up' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }
            `}>
              <Icon 
                name={card?.trend?.direction === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                size={12} 
                color="currentColor" 
                strokeWidth={2} 
              />
              <span className="font-caption text-[11px] font-medium">
                {card?.trend?.value}
              </span>
            </div>
          </div>
          <div className="font-heading font-bold text-[28px] text-foreground mb-4">
            {card?.value}
          </div>
          <div className="font-body text-[13px] text-muted-foreground">
            {card?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;